import { z } from 'zod';
import { ERROR_MESSAGES } from '~/constants';
import { optionSchemaRequired } from '~/features/types';

export const employerInfoSchema = z.object({
  legalEntityName: z
    .string()
    .min(1, ERROR_MESSAGES.REQUIRED)
    .max(255, ERROR_MESSAGES.MAX_CHARACTER_LIMIT(255)),
  employerEin: z
    .string()
    .regex(/^\d{9}$/, ERROR_MESSAGES.EXACT_CHARACTER_LIMIT(9))
    .or(z.literal('')),
  employerNpi: z
    .string()
    .regex(/^\d{10}$/, ERROR_MESSAGES.EXACT_CHARACTER_LIMIT(10))
    .or(z.literal('')),
  employerType: optionSchemaRequired,
  ownershipStructure: optionSchemaRequired,
  employerWebsite: z.string().max(8192, ERROR_MESSAGES.MAX_CHARACTER_LIMIT(8192)).or(z.literal('')),
});

export type EmployerInfoValues = z.infer<typeof employerInfoSchema>;
